import { useStore } from 'Stores/index'

import { useActiveUser } from 'Hooks'

/**
 * This hook returns true if active employee can purchase a device
 */
export function useCanEmployeePurchaseDevice(): boolean {
  const { orderStore } = useStore()
  const { isProductOffer } = orderStore
  const { activeEmployee } = useActiveUser()

  return (
    (isProductOffer && activeEmployee && activeEmployee.canPurchase) || false
  )
}
